import { Table, Typography } from 'antd';
import moment from 'moment';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import {
  DELETED,
  DELIVERED,
  ERROR,
  PENDING,
  READ,
  SENT,
} from '@app/components/Chat/constants';
import { SYSTEM_USER_ID } from '@app/constants';
import {
  COLUMNS,
  M_CHANEL,
  M_CLIENT,
  M_DATE,
  M_INTEGRATION,
  M_MESSAGE,
  M_STATUS,
  M_TYPE,
  M_USER,
} from '@app/pages/Messages/MessagesList/constants/columns';

import type { NMessages } from '@pages/Messages/MessagesList/Messages.types';

const { Text } = Typography;

export const MessagesTable: NMessages.MessagesTable = ({
  tableLoader,
  messages,
  rowsPerPage,
  setRowsPerPage,
  currentPage,
  setCurrentPage,
  isMobile,
}) => {
  const getStatusText = (status: string | null) => {
    switch (status) {
      case PENDING:
        return 'Ожидает';
      case SENT:
        return 'Отправлено';
      case DELIVERED:
        return 'Доставлено';
      case READ:
        return 'Прочитано';
      case DELETED:
        return 'Удалено';
      case ERROR:
        return 'Ошибка';
      default:
        return '';
    }
  };

  const data: NMessages.Columns[] = (messages || []).map(
    ({
      Id,
      ChannelName,
      ClientName,
      ClientId,
      Direction,
      IntegrationName,
      Message,
      Status,
      Timestamp,
      UserId,
      UserName,
    }) => {
      const isSystemUser = UserId === SYSTEM_USER_ID;

      return {
        key: Id,
        [M_DATE]: moment(Timestamp).format('DD.MM.YYYY HH:mm'),
        [M_TYPE]:
          Direction === 'in' ? <Text>Входящее</Text> : <Text>Исходящее</Text>,
        [M_CHANEL]: <Text>{ChannelName}</Text>,
        [M_INTEGRATION]: <Text>{IntegrationName}</Text>,
        [M_USER]: isSystemUser ? (
          <Text>{UserName}</Text>
        ) : (
          <Link to={`/users/edit/?id=${UserId}&key=1`}>{UserName}</Link>
        ),
        [M_CLIENT]: (
          <Link to={`/clients/card/?id=${ClientId}`}>{ClientName}</Link>
        ),
        [M_STATUS]: <Text>{getStatusText(Status)}</Text>,
        [M_MESSAGE]: <Text>{Message}</Text>,
      };
    }
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [rowsPerPage, setCurrentPage]);

  return (
    <Table
      loading={tableLoader}
      columns={COLUMNS}
      dataSource={data}
      scroll={{
        x: 1300,
      }}
      pagination={{
        size: isMobile ? 'small' : 'default',
        showSizeChanger: true,
        pageSize: rowsPerPage,
        current: currentPage,
        position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
        onShowSizeChange: (_, size) => setRowsPerPage(size),
        showTotal: (total, range) =>
          `Показаны ${range[0]}-${range[1]} из ${total}`,
        onChange: (page) => {
          setCurrentPage(page);
        },
      }}
    />
  );
};
